import {
  Container,
  Grid,
  Grow,
  Link,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import {
  SWAPSpace,
  Typography,
  Button,
  Paper,
  TextField,
  Skeleton,
} from '@yosgo/swap-ui'
import { useEffect, useState } from 'react'

import styled from 'styled-components'
import Footer from '../../components/Common/Footer'
import Navigation from '../../components/components/Navigation'
import AuthModal from '../../components/Common/AuthModal'
import {
  PricingCta,
  Product_Name_SearchEngine,
} from '../../components/components/Pricing'
import { FunctionProfileHead } from '../../components/Common/PagesHead'
import ReactTyped from 'react-typed'
import Fade from '../../components/Common/Fade'
import LoadToShow from '../../components/Common/LoadToShow'
import useWindowSize from '../../components/Hooks/useWindowSize'

declare const API_URL: string

const ProfilePage = () => {
  const [windowWidth, _] = useWindowSize()
  const [openAuth, setOpenAuth] = useState(false)
  const [authType, setAuthType] = useState<'register' | 'login'>('register')
  const [showSearchOutcome, setShowSearchOutcome] = useState(false)
  const [profileScale, setProfileScale] = useState(1.5)

  const profileWidth = 420
  const profileHeight = 175

  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const xsDown = useMediaQuery(theme.breakpoints.down('xs'))

  useEffect(() => {
    if (windowWidth > 0) {
      const width = window.innerWidth
      const _profileScale = width / profileWidth
      setProfileScale(_profileScale > 1 ? (smDown ? 1 : 1.5) : _profileScale)
    }
  }, [windowWidth])

  return (
    <>
      {windowWidth > 0 ? (
        <LoadToShow>
          <ProfileWrap>
            <FunctionProfileHead />
            <AuthModal
              type={authType}
              open={openAuth}
              onClose={() => setOpenAuth(false)}
            />
            <Navigation type="soho" page="normal" />
            <div>
              <Container maxWidth="xl">
                <SWAPSpace size={80} />
                <Typography variant="h5">
                  {Product_Name_SearchEngine}
                </Typography>
                <SWAPSpace />
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <Typography variant={smDown ? 'h2' : 'h1'}>
                    免費建立接案履歷，
                    <span style={{ color: '#00188B' }}>取得媒合機會</span>
                  </Typography>
                </div>
                <SWAPSpace size={36} />
                <Link
                  href="https://swap.work/profile/swap_demo_user"
                  target="_blank"
                  variant="body1"
                  color="textSecondary"
                >
                  ・接案履歷
                </Link>
                <SWAPSpace size={6} />
                <Link
                  href="/profile"
                  target="_blank"
                  variant="body1"
                  color="textSecondary"
                >
                  ・自由工作者搜尋引擎
                </Link>
                <SWAPSpace size={36} />
                <Button
                  onClick={() => {
                    setAuthType('register')
                    setOpenAuth(true)
                  }}
                  size="large"
                >
                  註冊帳號，建立我的接案履歷
                </Button>
                <SWAPSpace size={80} />
              </Container>
            </div>
            <div style={{ background: '#334267' }}>
              <SWAPSpace size={80} />
              {[
                {
                  subTitle: '媒合流程',
                  title: '',
                  connectLine: true,
                  child: false,
                  childLeft: undefined,
                  childRight: undefined,
                },
                {
                  subTitle: '',
                  title: '① 建立接案履歷',
                  connectLine: true,
                  child: true,
                  childLeft: (
                    <>
                      <SWAPSpace size={40} />
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          margin: `-${
                            (1 - profileScale) * 2 * profileHeight
                          }px 0px`,
                        }}
                      >
                        <div
                          style={{
                            width: profileWidth,
                            height: profileHeight,
                            position: 'relative',
                            transformOrigin: '50% 50%',
                            transform: `scale(${profileScale})`,
                          }}
                        >
                          <div
                            style={{
                              width: 300,
                              height: 133,
                              borderRadius: 4,
                              boxShadow:
                                '0px 3.23602px 12.9441px rgba(0, 0, 0, 0.1)',
                              backgroundColor: '#ffffff',
                              padding: 17,
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <img
                                  src="https://swap-img.swap.work/media/profile/girlphoto.png"
                                  height={43}
                                  width={43}
                                />
                                <Typography
                                  variant="h6"
                                  style={{ marginLeft: 8.5 }}
                                >
                                  林小美
                                </Typography>
                              </div>
                              <div style={{ marginTop: 5 }}>
                                {icon_verified}
                              </div>
                            </div>
                            <SWAPSpace size={13} />
                            <Typography
                              color="black800"
                              style={{ fontSize: 12, zoom: 0.8 }}
                            >
                              MEI DESIGN / 用設計串連生活的每個環結
                              <br /> Branding / Web Design / Illustration
                            </Typography>
                          </div>
                          {[
                            {
                              iconPath: `https://swap-img.swap.work/media/profile/newFeatureModal/icon2.png`,
                              text: '小美的設計作品集',
                              right: 0,
                              bottom: 67,
                            },
                            {
                              iconPath: `https://swap-img.swap.work/media/profile/newFeatureModal/icon1.png`,
                              text: '小美的個人網站',
                              right: 38,
                              bottom: 0,
                            },
                          ].map((i, index) => (
                            <div
                              key={index}
                              style={{
                                position: 'absolute',
                                right: i.right,
                                bottom: i.bottom,
                                display: 'flex',
                                alignItems: 'center',
                                width: 214,
                                height: 61.5,
                                borderRadius: 24,
                                boxShadow: ' 0px 6px 24px rgba(0, 0, 0, 0.1)',
                                backgroundColor: '#ffffff',
                                padding: 10.7,
                              }}
                            >
                              <img
                                src={i.iconPath}
                                height={40}
                                width={40}
                                style={{ marginRight: 10.5 }}
                              />
                              <Typography
                                variant="body1"
                                style={{ fontSize: 16, zoom: 0.7 }}
                              >
                                {i.text}
                              </Typography>
                            </div>
                          ))}
                        </div>
                      </div>
                      <SWAPSpace size={40} />
                    </>
                  ),
                  childRight: (
                    <>
                      <Typography
                        variant="h3"
                        style={{ fontWeight: 'normal' }}
                        color="white"
                      >
                        彙整經歷、亮點、作品集，讓接案資訊一目瞭然。
                      </Typography>
                    </>
                  ),
                },
                {
                  subTitle: '',
                  title: '② 客戶搜尋合作對象',
                  connectLine: false,
                  child: true,
                  childLeft: (
                    <>
                      <Paper
                        height="auto"
                        style={{ padding: xsDown ? 12 : 24 }}
                      >
                        <div style={{ width: '300px', position: 'relative' }}>
                          <TextField
                            fullWidth
                            height={56}
                            InputProps={{ startAdornment: icon_search }}
                            value=""
                            disabled
                          />
                          <div
                            style={{
                              position: 'absolute',
                              top: '15px',
                              left: '50px',
                            }}
                          >
                            <ReactTyped
                              strings={['Web Design']}
                              loop={true}
                              typeSpeed={200}
                              backDelay={3000}
                              style={{ fontSize: '18px' }}
                              onComplete={() => setShowSearchOutcome(true)}
                              onLastStringBackspaced={() =>
                                setShowSearchOutcome(false)
                              }
                            />
                          </div>
                        </div>
                        {showSearchOutcome ? (
                          <div>
                            <SWAPSpace />
                            <Grow
                              in={showSearchOutcome}
                              timeout={{ enter: 1000, exit: 1000 }}
                            >
                              <div
                                style={{
                                  width: 300,
                                  height: 133,
                                  borderRadius: 4,
                                  boxShadow:
                                    '0px 3.23602px 12.9441px rgba(0, 0, 0, 0.1)',
                                  backgroundColor: '#ffffff',
                                  padding: 17,
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <img
                                      src="https://swap-img.swap.work/media/profile/girlphoto.png"
                                      height={43}
                                      width={43}
                                    />
                                    <Typography
                                      variant="h6"
                                      style={{ marginLeft: 8.5 }}
                                    >
                                      林小美
                                    </Typography>
                                  </div>
                                  <div style={{ marginTop: 5 }}>
                                    {icon_verified}
                                  </div>
                                </div>
                                <SWAPSpace size={13} />
                                <Typography
                                  color="black800"
                                  style={{ fontSize: 12, zoom: 0.8 }}
                                >
                                  MEI DESIGN / 用設計串連生活的每個環結
                                  <br /> Branding / Web Design / Illustration
                                </Typography>
                              </div>
                            </Grow>
                          </div>
                        ) : (
                          <div>
                            <SWAPSpace />
                            <Fade>
                              <div
                                style={{
                                  width: 300,
                                  height: 133,
                                  borderRadius: 4,
                                  boxShadow:
                                    '0px 3.23602px 12.9441px rgba(0, 0, 0, 0.1)',
                                  backgroundColor: '#ffffff',
                                  padding: 17,
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '12px',
                                    }}
                                  >
                                    <Skeleton
                                      variant="circle"
                                      width={43}
                                      height={43}
                                    />
                                    <Skeleton variant="text" width={100} />
                                  </div>
                                  <div style={{ marginTop: 5 }}>
                                    <Skeleton
                                      variant="circle"
                                      width={18}
                                      height={18}
                                    />
                                  </div>
                                </div>
                                <SWAPSpace size={13} />
                                <Skeleton
                                  variant="text"
                                  width="100%"
                                  height={12}
                                />
                                <SWAPSpace size={6} />
                                <Skeleton
                                  variant="text"
                                  width="60%"
                                  height={12}
                                />
                              </div>
                            </Fade>
                          </div>
                        )}
                      </Paper>
                    </>
                  ),
                  childRight: (
                    <>
                      <Typography
                        variant="h3"
                        style={{ fontWeight: 'normal' }}
                        color="white"
                      >
                        客戶搜尋合作對象，增加合作的機會。
                      </Typography>
                    </>
                  ),
                },
              ].map((item, index) => (
                <div key={`接案履歷流程_${index}`}>
                  {item.subTitle ? (
                    <Typography
                      variant="h3"
                      style={{ textAlign: 'center' }}
                      color="white"
                    >
                      {item.subTitle}
                    </Typography>
                  ) : null}
                  {item.title ? (
                    <Typography
                      variant="d2"
                      color="white"
                      style={{ textAlign: 'center' }}
                    >
                      {item.title}
                    </Typography>
                  ) : null}
                  {item.child ? (
                    <>
                      <SWAPSpace size={40} />
                      <Container maxWidth="xl">
                        <Grid
                          container
                          spacing={6}
                          alignItems="center"
                          justify="center"
                          direction="column"
                        >
                          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            {item.childLeft}
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            {item.childRight}
                          </Grid>
                        </Grid>
                      </Container>
                    </>
                  ) : null}
                  {item.connectLine ? (
                    <div
                      style={{
                        height: 30,
                        width: 3,
                        background: 'white',
                        margin: '30px auto',
                        boxSizing: 'border-box',
                      }}
                    />
                  ) : null}
                </div>
              ))}
              <div id="search_engine" />
              <SWAPSpace size={80} />
            </div>
            {/* 延伸問答 */}
            <div>
              <SWAPSpace size={80} />
              <Container maxWidth="xl">
                <Typography
                  variant="title"
                  color="primary600"
                  style={{ paddingLeft: 3 }}
                >
                  接案履歷小提示
                </Typography>
                <SWAPSpace />
                <Typography variant="h1">使用方式</Typography>
                {[
                  {
                    title: '如何將自己的接案履歷上架到 SWAP 平台上？',
                    description: (
                      <>
                        註冊 SWAP 帳號後，請先
                        <span style={{ textDecoration: 'underline' }}>
                          完成實名認證
                        </span>
                        以及
                        <span style={{ textDecoration: 'underline' }}>
                          完整填寫接案履歷
                        </span>
                        後，即可上架你的履歷至{' '}
                        <Link href="/profile" target="blank">
                          SWAP 自由工作者搜尋引擎
                        </Link>
                        ，取得接案資格。
                      </>
                    ),
                  },
                  {
                    title: '如何主動使用接案履歷？',
                    description:
                      '每個接案履歷都有專屬的網址，你可以將此網址張貼在你的社群媒體，例如. 臉書、Instagram.. 等，讓社群媒體上的訪客看見你的接案資訊。',
                  },
                  {
                    title: '如何增加接案履歷的曝光量？',
                    description: (
                      <>
                        接案履歷在建立後將自動登錄{' '}
                        <Link
                          href="https://www.google.com/search?q=site%3A%2F%2Fswap.work%2Fprofile"
                          target="_blank"
                        >
                          Google 的索引
                        </Link>
                        ，你可以在履歷內填寫與你工作有關的關鍵字，進而提升
                        Google 搜尋結果的排名。
                      </>
                    ),
                  },
                ].map((item, index) => (
                  <div key={`進階功能_${index}`}>
                    {index === 0 ? (
                      <SWAPSpace size={30} />
                    ) : (
                      <SWAPSpace size={60} />
                    )}
                    <Typography variant="h3" style={{ fontWeight: 'normal' }}>
                      {item.title}
                    </Typography>
                    <SWAPSpace />
                    <Typography
                      variant="h6"
                      color="black900"
                      style={{ fontWeight: 'normal' }}
                    >
                      {item.description}
                    </Typography>
                  </div>
                ))}
              </Container>
              <SWAPSpace size={80} />
            </div>
            <div>
              <PricingCta />
            </div>
            <Footer />
          </ProfileWrap>
        </LoadToShow>
      ) : null}
    </>
  )
}

const ProfileWrap = styled.div`
  margin-top: 56px;
  width: 100%;
  overflow: hidden;
`

const icon_verified = (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_317_19008)">
      <path
        d="M11.1753 1.24367L12.1371 1.71183C12.2451 1.76436 12.3662 1.78355 12.4851 1.76694L13.5445 1.61892C13.6233 1.60791 13.7028 1.63373 13.76 1.68894L14.5301 2.43141C14.6165 2.51473 14.7258 2.5704 14.844 2.59134L15.8973 2.77795C15.9756 2.79183 16.0432 2.84094 16.0806 2.91114L16.5836 3.85524C16.64 3.96118 16.7268 4.04791 16.8327 4.10435L17.7768 4.60732C17.847 4.64472 17.8961 4.71231 17.91 4.79064L18.0966 5.84396C18.1176 5.96215 18.1732 6.07143 18.2565 6.15784L18.999 6.92794C19.0542 6.9852 19.08 7.06467 19.069 7.14344L18.921 8.20288C18.9044 8.32176 18.9236 8.44289 18.9761 8.55082L19.4443 9.51266C19.4791 9.58418 19.4791 9.66774 19.4443 9.73926L18.9761 10.7011C18.9236 10.809 18.9044 10.9302 18.921 11.049L19.069 12.1085C19.08 12.1873 19.0542 12.2667 18.999 12.324L18.2565 13.0941C18.1732 13.1805 18.1176 13.2898 18.0966 13.408L17.91 14.4613C17.8961 14.5396 17.847 14.6072 17.7768 14.6446L16.8327 15.1476C16.7268 15.204 16.64 15.2907 16.5836 15.3967L16.0806 16.3408C16.0432 16.411 15.9756 16.4601 15.8973 16.474L14.844 16.6606C14.7258 16.6815 14.6165 16.7372 14.5301 16.8205L13.76 17.563C13.7028 17.6182 13.6233 17.644 13.5445 17.633L12.4851 17.485C12.3662 17.4684 12.2451 17.4876 12.1371 17.5401L11.1753 18.0082C11.1038 18.0431 11.0202 18.0431 10.9487 18.0082L9.98686 17.5401C9.87893 17.4876 9.75779 17.4684 9.63891 17.485L8.57948 17.633C8.5007 17.644 8.42124 17.6182 8.36397 17.563L7.59388 16.8205C7.50746 16.7372 7.39819 16.6815 7.27999 16.6606L6.22667 16.474C6.14835 16.4601 6.08075 16.411 6.04335 16.3408L5.54038 15.3967C5.48394 15.2907 5.39722 15.204 5.29128 15.1476L4.34718 14.6446C4.27698 14.6072 4.22786 14.5396 4.21399 14.4613L4.02738 13.408C4.00644 13.2898 3.95076 13.1805 3.86745 13.0941L3.12498 12.324C3.06977 12.2667 3.04395 12.1873 3.05496 12.1085L3.20297 11.049C3.21958 10.9302 3.2004 10.809 3.14787 10.7011L2.67971 9.73926C2.6449 9.66774 2.6449 9.58418 2.67971 9.51266L3.14787 8.55082C3.2004 8.44289 3.21958 8.32176 3.20297 8.20288L3.05496 7.14344C3.04395 7.06467 3.06977 6.9852 3.12498 6.92794L3.86745 6.15784C3.95076 6.07143 4.00644 5.96215 4.02738 5.84396L4.21399 4.79064C4.22786 4.71231 4.27698 4.64472 4.34718 4.60732L5.29128 4.10435C5.39722 4.04791 5.48394 3.96118 5.54038 3.85525L6.04335 2.91114C6.08075 2.84094 6.14835 2.79183 6.22667 2.77795L7.27999 2.59134C7.39819 2.5704 7.50746 2.51473 7.59388 2.43141L8.36397 1.68894C8.42124 1.63373 8.5007 1.60791 8.57948 1.61892L9.63891 1.76694C9.75779 1.78355 9.87893 1.76436 9.98686 1.71183L10.9487 1.24367C11.0202 1.20886 11.1038 1.20886 11.1753 1.24367Z"
        fill="#3555D5"
        stroke="#F7B52C"
        strokeWidth="0.345175"
      />
      <circle
        cx="11.0617"
        cy="9.62592"
        r="6.73092"
        stroke="#C1C7ED"
        strokeWidth="0.345175"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.675 7.59488C14.8435 7.76338 14.8435 8.03657 14.675 8.20507L10.7199 12.1602C10.5514 12.3287 10.2782 12.3287 10.1097 12.1602L8.31192 10.3624C8.14342 10.1939 8.14342 9.92072 8.31192 9.75222C8.48042 9.58373 8.75361 9.58373 8.92211 9.75222L10.4148 11.2449L14.0648 7.59488C14.2333 7.42638 14.5065 7.42638 14.675 7.59488Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_317_19008"
        x="0.706741"
        y="0.133644"
        width="20.7105"
        height="20.7105"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.862938" />
        <feGaussianBlur stdDeviation="0.862938" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_317_19008"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_317_19008"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

const icon_search = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: 4 }}
  >
    <path
      d="M15.5 14.2109H14.71L14.43 13.9409C15.41 12.8009 16 11.3209 16 9.71094C16 6.12094 13.09 3.21094 9.5 3.21094C5.91 3.21094 3 6.12094 3 9.71094C3 13.3009 5.91 16.2109 9.5 16.2109C11.11 16.2109 12.59 15.6209 13.73 14.6409L14 14.9209V15.7109L19 20.7009L20.49 19.2109L15.5 14.2109ZM9.5 14.2109C7.01 14.2109 5 12.2009 5 9.71094C5 7.22094 7.01 5.21094 9.5 5.21094C11.99 5.21094 14 7.22094 14 9.71094C14 12.2009 11.99 14.2109 9.5 14.2109Z"
      fill="#6F6F6F"
    />
  </svg>
)

export default ProfilePage
